<template>
  <transition name="fades">
    <div class="leon_alter" :class="typeId ? 'leon_alter' + typeId : ''" style="z-index: 2001" v-if="show">
      <div class="leon_alter_box" :class="{remaidBox: code && text.length > 200}">
        <div class="title bold">{{title}}</div>
        <div class="text" :class="{remaid: code && text.length > 200}">{{text}}</div>
        <div v-if="img" class="img">
          <img :src="img" alt="" srcset="">
        </div>
        <div class="btn">
          <el-button type="primary" round @click="yesBtn">{{yesTxt}}</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LeonAlter',
  data () {
    return {
      show: false,
      title: '',
      text: '',
      code: false,
      yesTxt: '确定',
      img: '',
      click: null,
      confirm: null,
      typeId: ''    // 提醒id tips和摄像头或者别的提醒可以同时存在
    }
  },
  methods: {
    yesBtn () {
      this.confirm && this.confirm()
      this.click && this.click()
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>

::-webkit-scrollbar {
  /*滚动条整体样式*/
  display: block;
  width : 8px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 120px;
}
::-webkit-scrollbar-corner{
  display: none;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4px;
  background: #D9DAE3;
}
.leon_alter{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .leon_alter_box{
    background: #FFFFFF;
    border-radius: 16px;
    text-align: center;
    width: 402px;
    padding: 32px;
    .title{
      font-size: 20px;
      line-height: 26px;
    }
    .img{
      img{
        width: 100%;
      }
    }
    .text{
      font-size: 16px;
      line-height: 21px;
      margin-top: 16px;
      white-space: pre-wrap;
      word-break: break-word;
    }
    .remaid{
      max-height: 400px;
      overflow: hidden;
      overflow-y: scroll;
    }
    .btn{
      margin-top: 24px;
    }
  }
  .remaidBox{
    width: 630px;
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/leonAlter/src/main.vue